import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * A utility function for conditionally joining Tailwind CSS classes together
 * and handling class conflicts correctly.
 * 
 * @param  {...any} inputs - Class name inputs (string, object with boolean values, arrays, etc.)
 * @returns {string} - Merged and cleaned class names string
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
